import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateProfile, changePassword, resetChangePasswordStatus, getProfile } from '../../reducers/user/duck';
import { logout } from '../../reducers/oauth/duck';
import UserScreen from './UserScreen';

const mapStateToProps = ({
  userStore: {
    profile, id, email, updateProfileStatus,
    updateProfileError, emailSubscriptions, changePasswordStatus,
    changePasswordError,
    havePassword,
    sidebarStatus,
  },

}) => ({
  profile,
  id,
  email,
  updateProfileStatus,
  updateProfileError,
  emailSubscriptions,
  changePasswordStatus,
  changePasswordError,
  havePassword,
  sidebarStatus,
});
const mapDispatchToProps = {
  updateProfile, logout, changePassword, resetChangePasswordStatus, getProfile,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserScreen));



// WEBPACK FOOTER //
// ./src/containers/UserScreen/index.js